<template lang="pug">
  
  .wrapper.wrapper-content.animated.fadeInRight
    .row
      .col-xs-12
        .ibox.float-e-margins
          .ibox-title
            h2 {{ id ? 'Edit' : 'Create' }} Project Name
          
          .ibox-content
            .row
              .col-xs-12
                form(role="form" v-on:submit.prevent="onSubmit")                  
                  .row
                    .col-md-6
                        gmap-map(:center="gmapOptions.center" :zoom="gmapOptions.zoom" style="width: 100%; height: 400px;" :options="gmapOptions.options")
                          gmap-marker(v-if="marker.enabled" :position="{ lat: marker.position.lat, lng: marker.position.lng }" :draggable="true" @dragend="onMarkerMove")
                    .col-md-6
                      .form-group
                        label AREA
                        gmap-autocomplete.form-control#gmap-autocomplete(placeholder="Enter location" @place_changed="placeChange" :select-first-on-enter="true" required)
                      .form-group
                        label LATITUDE
                        input.form-control(type="text" v-model="projectName.latitude" @blur="changeGeometry" required)
                      .form-group
                        label LONGITUDE
                        input.form-control(type="text" v-model="projectName.longitude" @blur="changeGeometry" required)
                      .form-group(:class="error.project_name ? 'has-error' : ''")
                        label PROJECT TITLE
                        input.form-control(type="text" placeholder="Name" v-model="projectName.title" required)
                        p.help-block {{ error.project_name }}
                      div
                        button.btn.btn-primary(type="submit")
                          span(v-if="id") Save
                          span(v-else) Create
                        | &nbsp;&nbsp;
                        button.btn.btn-white(type="button" @click="$router.go(-1)") Cancel

</template>

<script>
  import axios from 'axios'
  import toastr from 'toastr'
  import 'toastr/build/toastr.min.css'
  import numeral from 'numeral'
  
  export default {
    data () {
      return {
        id: this.$route.params.id,
        projectName: {},
        gmapOptions: {
          center: {
            lat: 13.724561,
            lng: 100.4930269
          },
          zoom: 12,
          options: {
            scrollwheel: false,
            mapTypeControl: false,
            streetViewControl: false
          }
        },
        marker: {
          enabled: false,
          position: {
            lat: 0,
            lng: 0
          }
        },
        error: {
          project_name: ''
        }
      }
    },
    mounted () {
      if (this.id) this.fetchProjectName()
      else this.projectName.create_by_id = this.$ls.get('user').id
    },
    methods: {
      deformatNumber (number) {
        return numeral(number).value()
      },
      fetchProjectName () {
        axios.get(`project/title/id/${this.id}`).then((res) => {
          switch (res.data.responseCode) {
            case 200:
              this.projectName = res.data.data
              this.projectName.update_by_id = this.$ls.get('user').id
              document.getElementById('gmap-autocomplete').value = this.projectName.location
              this.changeGeometry()
              console.log(this.projectName)
              break
            case 405:
              toastr.error('This account has login by other.', res.data.message, { timeOut: 4000 })
              this.$router.push('/login')
              break
            case 406:
              toastr.error('This account has been deleted please contact admin.', res.data.message, { timeOut: 4000 })
              this.$router.push('/login')
              break
            default:
              console.log(res.data.message)
          }
        })
      },
      placeChange (place) {
        console.log(place)
        this.gmapOptions.center = {
          lat: place.geometry.location.lat(),
          lng: place.geometry.location.lng()
        }
        this.marker.enabled = true
        this.marker.position = {
          lat: place.geometry.location.lat(),
          lng: place.geometry.location.lng()
        }
        this.projectName.location = place.formatted_address
        this.projectName.latitude = place.geometry.location.lat()
        this.projectName.longitude = place.geometry.location.lng()
      },
      changeGeometry () {
        if (this.projectName.latitude && this.projectName.longitude) {
          this.gmapOptions.center = {
            lat: Number(this.projectName.latitude),
            lng: Number(this.projectName.longitude)
          }
          this.marker.enabled = true
          this.marker.position = {
            lat: Number(this.projectName.latitude),
            lng: Number(this.projectName.longitude)
          }
        }
      },
      onMarkerMove (place) {
        console.log(place)
        this.projectName.latitude = place.latLng.lat()
        this.projectName.longitude = place.latLng.lng()
        this.marker.position = {
          lat: place.latLng.lat(),
          lng: place.latLng.lng()
        }
      },
      onSubmit () {
        if (this.id) {
          axios.put('project/title', this.projectName).then((res) => {
            switch (res.data.responseCode) {
              case 200:
                toastr.success('Change Success', { timeOut: 4000 })
                this.$router.go(-1)
                break
              case 401:
                this.error.project_name = 'Project Title พบชื่อซ้ำ กรุณาตรวจสอบใหม่อีกครั้ง'
                break
              case 405:
                toastr.error('This account has login by other.', res.data.message, { timeOut: 4000 })
                this.$router.push('/login')
                break
              case 406:
                toastr.error('This account has been deleted please contact admin.', res.data.message, { timeOut: 4000 })
                this.$router.push('/login')
                break
              default:
                console.log(res.data.message)
            }
          })
        } else {
          axios.post('project/title', this.projectName).then((res) => {
            switch (res.data.responseCode) {
              case 200:
                toastr.success('Create Success', { timeOut: 4000 })
                this.$router.go(-1)
                break
              case 401:
                this.error.project_name = 'Project Title พบชื่อซ้ำ กรุณาตรวจสอบใหม่อีกครั้ง'
                break
              case 405:
                toastr.error('This account has login by other.', res.data.message, { timeOut: 4000 })
                this.$router.push('/login')
                break
              case 406:
                toastr.error('This account has been deleted please contact admin.', res.data.message, { timeOut: 4000 })
                this.$router.push('/login')
                break
              default:
                console.log(res.data.message)
            }
          })
        }
      }
    }
  }
</script>



// WEBPACK FOOTER //
// edit.vue?52c106ce